import { CommonModule } from '@angular/common';
import { Component, Signal, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IIqMcInfoBadge, McQuery, emptyIqMcInfoBadge } from './models';
import { IqMcInfoBadgeMapperService } from './services';

@Component({
    selector: 'iq-mc-info-badge',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    templateUrl: './iq-mc-info-badge.component.html',
    styleUrl: './iq-mc-info-badge.component.scss',
})
export class IqMcInfoBadgeComponent {
    params = input<McQuery>();

    constructor(private _mapper: IqMcInfoBadgeMapperService) {}

    settings: Signal<IIqMcInfoBadge> = computed(() => {
        const settings: IIqMcInfoBadge = this._mapper.mapMciInfoBadgeSettings(
            this.params(),
        );
        return settings ?? emptyIqMcInfoBadge;
    });
}
